<template>
  <FlatButton
    :class="$style.button"
    :disabled="disabled"
    variant="secondary"
    size="medium"
  >
    評価を依頼
    <template #icon>
      <IconStar />
    </template>
  </FlatButton>
</template>

<script setup lang="ts">
import IconStar from '@/components/icons/IconStar.vue'
import FlatButton from '@/components/atoms/FlatButton.vue'

withDefaults(defineProps<{ disabled?: boolean }>(), { disabled: false })
</script>
<style lang="scss" module>
.button {
  justify-content: center;
}
</style>
